import { DEFAULT_EXERCISE_PAGE_SIZE, MAX_EXERCISE_PAGE_SIZE, toExerciseListParams, } from "@repo/contract/catalog";
import { fetchCatalogFilters, fetchExerciseDetail, fetchExerciseList, reportExercise, } from "./api";
import { catalogKeys } from "./keys";
/**
 * `/catalog/filters` is static for the life of a seed, which changes only with
 * a deploy. A day keeps a long-open app from re-reading it on every mount
 * without pinning a stale vocabulary forever.
 */
const FILTERS_STALE_MS = 24 * 60 * 60 * 1000;
/**
 * The page size a caller asked for, made safe: `DEFAULT_EXERCISE_PAGE_SIZE`
 * when absent, never above `MAX_EXERCISE_PAGE_SIZE` (the server answers a
 * larger one with a 422, not a smaller page) and never below one.
 */
export function exercisePageSize(limit) {
    if (limit === undefined || !Number.isFinite(limit)) {
        return DEFAULT_EXERCISE_PAGE_SIZE;
    }
    return Math.min(Math.max(1, Math.trunc(limit)), MAX_EXERCISE_PAGE_SIZE);
}
/**
 * The catalogue list, a page at a time over the opaque `cursor`. The next page
 * parameter is exactly the `nextCursor` the server sent; `null` ends the list,
 * because a request after the end gets the FIRST page back
 * (`exerciseListOutput.nextCursor`).
 */
export function exerciseListInfiniteOptions(api, filter = {}) {
    const query = {
        ...filter,
        limit: exercisePageSize(filter.limit),
    };
    return {
        getNextPageParam: (lastPage) => lastPage.nextCursor,
        initialPageParam: null,
        queryFn: ({ pageParam, signal }) => fetchExerciseList(api, pageParam === null ? query : { ...query, cursor: pageParam }, { signal }),
        queryKey: catalogKeys.list(toExerciseListParams(query)),
    };
}
export function exerciseDetailOptions(api, id, locale) {
    return {
        queryFn: ({ signal }) => fetchExerciseDetail(api, id, locale, { signal }),
        queryKey: catalogKeys.detail(id, locale),
    };
}
export function catalogFiltersOptions(api, locale) {
    return {
        queryFn: ({ signal }) => fetchCatalogFilters(api, locale, { signal }),
        queryKey: catalogKeys.filters(locale),
        staleTime: FILTERS_STALE_MS,
    };
}
/**
 * "Dados errados?" (`D199`). Invalidates nothing: a report changes no read —
 * the catalogue is corrected, if at all, by a re-ingestion the owner ships
 * after reading the digest, never by this write.
 */
export function reportExerciseMutation(api) {
    return {
        mutationFn: ({ exerciseId, ...input }) => reportExercise(api, exerciseId, input),
        mutationKey: ["catalog", "reports", "create"],
    };
}
//# sourceMappingURL=options.js.map